export class Reserva {
    id:number=0;
    nombre:string='';
    hora:string='';
    personas:number=0;
    del:string='';
    al:string='';
}
